import { useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';

import { CUSTOMER_REQUEST_INVESTMENT } from './queries';

const useCustomerRequestNewInvestment = () => {
  const [requested, setRequested] = useState(false);

  const { addToast } = useToasts();

  const [runMutation, { loading }] = useMutation(CUSTOMER_REQUEST_INVESTMENT, {
    onCompleted: ({ customerRequestNewInvestment }) => {
      if (customerRequestNewInvestment && customerRequestNewInvestment.success) setRequested(true);
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          addToast(e.message, {
            appearance: 'error',
            autoDismiss: true,
          });
        });
      } else {
        addToast('Something unexpected happened', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!requested) {
      runMutation();
    }
  };

  return {
    requested,
    handleSubmit,
    loading,
  };
};

export default useCustomerRequestNewInvestment;
